import { useEffect, useState } from 'react';
import { subscribeToast, type ToastEntry } from '@/lib/toast';
import { Icon } from './Icon';

/** Стек тост-уведомлений (как в референсе) – монтируется один раз в AppLayout. */
export function ToastStack() {
  const [toasts, setToasts] = useState<ToastEntry[]>([]);

  useEffect(() => subscribeToast(setToasts), []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div className="toast" key={t.id}>
          <span className="toast__icon">
            <Icon name="check" size={16} />
          </span>
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
